var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.error)?_c('v-sheet',_vm._b({staticClass:"fill-height d-flex flex-column justify-center align-center py-4",attrs:{"color":"grey lighten-3"}},'v-sheet',_vm.$attrs,false),[_c('v-icon',{staticClass:"static",attrs:{"x-large":"","color":_vm.fileType && _vm.fileType.color ? _vm.fileType.color : 'primary'}},[_vm._v(" "+_vm._s(_vm.fileType ? _vm.fileType.icon : 'fas fa-file')+" ")]),_c('span',{staticClass:"pt-4"},[_vm._v(_vm._s(_vm.fileType ? _vm.fileType.name : '')+" ")])],1):_c('v-img',_vm._b({attrs:{"src":_vm.preview +
        `?${
            _vm.$attrs.width
                ? 'maxImgWidth=' + _vm.$attrs.width * 1.5
                : _vm.$attrs.height
                ? 'maxImgHeight=' + _vm.$attrs.height * 1.5
                : 'maxImgWidth=200'
        }&maxWaitSeconds=20`},on:{"error":_vm.handleError}},'v-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }